import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import pluralize from 'pluralize';
import Image from '../../image/image';
import Pixeltext from '../../svg/pixeltext';
import css from './header.scss';

import { formatNumber, DateFormatter } from '../../../utils/date';

import Share from '../../../components/share/share';

export default class EditorialHeader extends Component {
	static propTypes = {
		editorial: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		onLoad: PropTypes.func,
	};

	static defaultProps = {
		onLoad: () => {},
	};

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentWillReceiveProps(nextProps) {
		if (!nextProps.editorial.image && !this.missingImage) {
			this.missingImage = true;
			nextProps.onLoad();
		} else {
			this.missingImage = false;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (nextProps.editorial.id !== this.props.editorial.id);
	}

	render() {
		const { date, title, excerpt, subtitle, users, releaseDate, createdDate } = this.props.editorial;
		let editorialDate = new DateFormatter(releaseDate || createdDate);

		return (
			<header className='editorial-header'>
				{(!!this.props.editorial.image) && (
					<div className='editorial-header__hero'>
						<Image
							img={this.props.editorial.image}
							alt={this.props.editorial.image_alt}
							span='span14'
							className='span14 editorial-header__hero__img'
							browser={this.props.browser}
							onLoad={() => {
								this.props.onLoad();
							}}
						/>
					</div>
				)}
				<div className='span14-mobile pixel-pattern editorial-header__leftbox'>
					<Pixeltext text={editorialDate.date} className='editorial__fancytext' />
					<div className='editorial-header__leftbox__info editorial-header__leftbox__info--faded'>{editorialDate.monthAndYear}</div>
					<div className='editorial-header__leftbox__info'>{pluralize(this.props.editorial.types.name, 1)}</div>
				</div>
				<div className='span14-mobile editorial-header__rightbox'>
					<div className='editorial-header__rightbox__share'>
						<Share title={this.getTitle()} url={window.location.href} browser={this.props.browser} />
					</div>
					<div className='span10 span14-mobile editorial-header__rightbox__container'>
						<div className='editorial-header__rightbox__type'>{this.getTypeAndAuthor()}</div>
						<h1 className='editorial-header__rightbox__title'>{this.getTitle()}</h1>
						<p className='editorial-header__rightbox__subtitle'>{excerpt || subtitle}</p>
					</div>
				</div>
			</header>
		);
	}

	getTitle() {
		//@TODO might need some logic to add article-type to title
		let { title, typeId } = this.props.editorial;

		return title;
	}

	getTypeAndAuthor() {
		let { layoutType, users } = this.props.editorial;

		if (!layoutType || !(users && users.name)) {
			return '';
		}

		switch (layoutType) {
			case 1:
			layoutType = 'Interview';
			break;
			case 2:
			layoutType = 'Article';
			break;
		}

		return `${layoutType} by ${users.name}`;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/editorial/header/header.js
 **/